import { Typography } from '@material-ui/core';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'block'
    }
  });

interface IListTextOwnProps {
  values: any;
}
type IListTextProps = IListTextOwnProps & WithStyles<typeof styles>;

function ListText(props: IListTextProps) {
  const { classes } = props;
  return (
    <div>
      {props.values.map((value, index) => {
        return (
          <span className={classes.root} key={index}>
            {value}
          </span>
        );
      })}
    </div>
  );
}

export default withStyles(styles)(ListText);
